// extracted by mini-css-extract-plugin
module.exports = {"skillContainer":"Container_skillContainer__2Bh3f","heading":"Container_heading__329ju","years":"Container_years__9wkv8"};